// Environment-driven API URL
// Injected at build time via REACT_APP_API_URL (configured in Jenkinsfile or .env)
// Staging API: https://staging.iccpanel.com/api/v1/betwin
// Prod API:    https://iccpanel.com/api/v1/betwin
const BASE_URL =
  process.env.REACT_APP_API_URL || "https://staging.iccpanel.com/api/v1/betwin";

export default BASE_URL;

